module.exports = __webpack_public_path__ + "img/cerrar.fba26098.png";